import "core-js/modules/es.error.cause.js";

/**
 * 可根据用户相关设置自动请求远程数据
 */

/**
 * 处理本地数据分页的插件，
 * 使用方法：
 * new FetchDataPlugin({
 *   fetchData () { return new Promise(...)},
 *   formatData (data) { return data.list },
 *   formatPage (data) { return data.pager }
 * })
 */
export default class FetchDataPlugin {
  constructor({
    fetchData,
    formatData,
    formatPage
  } = {}) {
    if (!fetchData || !formatData || !formatPage) {
      throw new Error('[FetchDataPlugin] 需要指定函数 fetchData，formatData，formatPage');
    }

    this.fetchData = fetchData;
    this.formatData = formatData;
    this.formatPage = formatPage;
  }

  install(ctx) {
    ctx.plugin('fetch-data', async (vm, data, query, cb) => {
      const {
        fetchData
      } = this;
      const {
        pageSize,
        currentPage
      } = vm;
      fetchData.call(vm, {
        pageSize,
        currentPage,
        ...(query || {})
      }).then(result => {
        cb(result);
      });
    });
    ctx.plugin('format-page', (vm, pager = {}, data) => {
      const {
        formatPage
      } = this;
      const {
        pageSize
      } = vm;
      const {
        currentPage = 0
      } = vm;

      if (!formatPage) {
        return {
          total: 0,
          pageSize,
          pageNumber: currentPage
        };
      }

      const result = formatPage.call(vm, data);
      return {
        total: 0,
        pageSize,
        pageNumber: currentPage,
        ...(result || {})
      };
    });
    ctx.plugin('format-data', (vm, data) => {
      const {
        formatData
      } = this;

      if (!formatData) {
        return data;
      }

      return formatData.call(vm, data);
    });
  }

}